export default __webpack_public_path__ + "static/media/klarna.b8a3f6c1.svg";